import { AuthService } from './../../../services/auth.service';
import { Client } from './../../../models/client';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-client-edit',
  templateUrl: './client-edit.component.html',
  styleUrls: ['./client-edit.component.css']
})
export class ClientEditComponent implements OnInit {

  client: Client;
  passwordChange = {
    enabled: false,
    password: '',
    passwordConfirm: ''
  };
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isAccountPage: boolean;
  reservedUsernames: string[];
  pack: Array<Select2OptionData>;
  pnotify = undefined;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    pnotifyService: PNotifyService
  ) {
    this.client = new Client();
    this.reservedUsernames = [];
    this.pack = [
      { id: '', text: 'Choisir un type' },
      { id : '1', text: 'Start' },
      { id : '2', text: 'Essentiel' },
      { id : '3', text: 'Pro' },
    ];
    this.isAccountPage = (this.router.url.indexOf('/account') === 0);
    this.route.params.subscribe(params => {
      const id = this.isAccountPage ? authService.getUser().id : params['id'];
      this.http.get(
        '/api/client/' + id
      ).subscribe((client: any) => {
        this.client = client;
        this.pack = this.pack.map((data, index) => {
          return {
            id: data.id,
            text: data.text,
            selected: (data.id == client.pack) ? true : false
           };
        });
        $('#image-cropper').cropit('imageSrc', this.client.image);
        this.http.get(
          '/api/client/reservedUsernames/' + id
        ).subscribe((usernames: any[]) => {
          for (let i = 0; i < usernames.length; i++) {
            this.reservedUsernames.push(usernames[i].username);
          }
        });
      });
    });
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
    $('#image-cropper').cropit({
      allowDragNDrop: false,
      smallImage: 'allow',
      imageSrc: 'assets/images/user.png'
    });
    $('.select-image-btn').click(function () {
      $('.cropit-image-input').click();
    });
  }

  onUsernameChange() {
    this.client.username = this.client.username.replace(/\s/g, '');
  }

  packChanged(e: any) {
    this.client.pack = e.value;
  }

  onSubmit(): void {
    this.client.expiration = moment(this.client.expiration).format('YYYY-MM-DD HH:mm:ss');
    this.client.lastConnection = moment(this.client.lastConnection).format('YYYY-MM-DD HH:mm:ss');
    if (this.passwordChange.enabled) {
      this.client.passwordBrute = this.passwordChange.password;
    }
    const previewSize = $('#image-cropper').cropit('previewSize');
    const quality = previewSize.width > 100 ? 100 / previewSize.width : 1;
    if ($('#image-cropper').cropit('imageSrc')) {
      this.client.image = $('#image-cropper').cropit('export', {
        type: 'image/jpeg',
        smallImage: 'allow',
        quality: quality,
        fillBg: '#fff',
        originalSize: false
      });
    }
    this.http.put(
      '/api/client/' + this.client.id,
      {
        client: this.client,
        passwordChange: this.passwordChange
      }
    ).subscribe(
      (client: Client) => {
        this.client = client;
        this.router.navigate(this.isAccountPage ? ['/account/client/view'] : ['/client/view', this.client.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/client/client-edit/client-edit.component.ts